import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import { store } from 'store/store';

const httpLink = createHttpLink({
  uri: '/api/user-profile',
});

const authLink = setContext((_, { headers }) => {
  const { token } = store.getState().auth.data;
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const apollo = new ApolloClient({
  link: authLink.concat(httpLink),
  // TODO [ZSz]: Do we really need cache? In most cases we would like to be sure we are fetching without cache
  cache: new InMemoryCache(),
});
